import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'


const Dashboard = () => {

  const navigate = useNavigate();

  const options = [
    {
      name: 'Account Overview',
      link: 'account-overview',
    },
    {
      name: 'Payment Method',
      link: 'payment-method',
    },
    {
      name: 'Create & View Page',
      link: 'create-view-page',
    },
    {
      name: 'Add & View People',
      link: 'add-view-people',
    },
  ];

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light p-3 rounded-3 d-flex flex-wrap align-items-center gap-3'>
          <h4 className='mb-0 text-primary'>Siddharth Dongre</h4>

          <select className="form-select w-auto me-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>

          <button type="button" className='btn btn-primary d-flex align-items-center gap-1' onClick={() => navigate(`/campaigns/basic-info`)}>
            <img src="/images/icons/add-white.svg" style={{ height: '20px' }} alt="add" />
            <span>Create Campaign</span>
          </button>

          <button type="button" className='btn btn-primary'>Review and Publish</button>

          <button type="button" className='bg-white border-0 shadow-sm p-1 rounded-1'>
            <img src="/images/icons/three-dot-black.svg" style={{ height: '20px' }} alt="three-dot-black" />
          </button>
        </div>

        {/* Options */}
        <div className='d-flex flex-wrap gap-3 align-items-center justify-content-between my-3'>
          {
            options.map((value, index) => (
              <div className={`${window.location.href.includes(value.link) ? 'bg-primary text-white' : 'bg-light text-secondary'} cursor-pointer flex-grow-1 py-2 rounded-3 text-center fs-5`} onClick={() => navigate(value.link)} key={index}>{value.name}</div>
            ))
          }
        </div>

        <Outlet />
      </section> 
    </>
  )
}

export default Dashboard
